import { useEffect, useState } from "react";
import { MainWrapper } from "../component/MainWrapper";
import { Filter } from "./component/Filter";
import { Checkbox } from "sr/helpers";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { WhiteBtn } from "./component/WhiteBtn";
import { TableRow } from "./component/TableRow";
import { Link } from "react-router-dom";
import { WorkOrderPopup } from "./component/WordOrderPopup";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { FormattedMessage, useIntl } from "react-intl";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { updateWorkorder } from "sr/utils/api/company/workorder/updateWorkorder";
import { ReactDatePicker } from "sr/helpers/ui-components/ReactDatePicker";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { useAuth } from "app/pages/module/auth";
import { fetchCustomerData } from "sr/helpers/apiFunctions/fetchCustomerData";
import { Pagination } from "app/pages/component/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { fetchSupervisor } from "sr/redux/reducers/supervisor";
import { AppDispatch, RootState } from "sr/redux/store";
import { fetchWorkOrder } from "sr/helpers/apiFunctions/WorkOrder/fetchWorkOrder";
import { StatusTab } from "./component/StatusTab";
import { fetchCustomerLocations } from "sr/helpers/apiFunctions/fetchCustomerLocations";
import { fetchWorkOrderModel } from "sr/helpers/apiFunctions/WorkOrder/fetchWorkOrderModel";
import { Empty } from "../candidates/component/Empty";
import { ModelWrapper } from "../component/ModelWrapper";
import { DeleteConfirmation } from "app/pages/component/DeleteConfirmation";
import { deleteRecWorkOrder } from "sr/utils/api/company/workorder/deleteRecWorkOrder";
import { AddressDisplay } from "sr/helpers/functions/AddressDisplay";
import { TermsAgreePopup } from "app/pages/module/auth/TermsAgreePopup";
import { Button } from "sr/helpers/ui-components/company/Button";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { toast } from "react-toastify";
import { getContractor } from "sr/utils/api/company/workorder/getContractor";
export const WorkOrder = () => {
  const [customer, SetCustomer] = useState("");
  const [location, setLocation] = useState("");
  const [customerLocations, setCustomerLocations] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [status, setStatus] = useState<any>(["publish", "draft"]);
  const [userId, setUserId] = useState(null);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [editId, setEditId] = useState(null);
  const [limit, setLimit] = useState<number>(50);
  const [page, setPage] = useState<number>(1);
  const [totalPage, settotalPage] = useState(0);
  const [customerLocationId, setCustomerLocationId] = useState<string>();
  const { userType } = useAuth();
  const [statusCount, setStatusCount] = useState<any>();
  const [customers, setCustomers] = useState<any>();
  const dispatch = useDispatch<AppDispatch>();
  const supervisorData = useSelector((item: any) => item?.supervisor?.data);
  const [Filterdata, setFilterdata] = useState<any>();
  const [isCompletionDate, setIsCompletionDate] = useState(false);
  const [type, setType] = useState<string>("one time");
  const [active, setActive] = useState("");
  const [activeType, setActiveType] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState<string>("");
  const [customDateFilterError, setCustomDateFilterError] = useState(null);
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const [showNoContractorAlert, setShowNoContractorAlert] = useState(false);
  const [checkingContractors, setCheckingContractors] = useState(false);
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const instruction = "show";
  useEffect(() => {
    const { user_id } = getUserDetails();
    setUserId(user_id);
    (async () => {
      const userFullProfileRes = await getUserFullProfile();

      setUserFullProfile(userFullProfileRes?.data);
    })();
  }, []);

  //If supervisordata is not available
  useEffect(() => {
    if (userId && userType === "supervisor") {
      if (!supervisorData) {
        dispatch(fetchSupervisor({ id: userId }));
      }
    }
  }, [userId, userType, dispatch]);
  const fetchAllLocation = async (companyId) => {
    const data = await fetchCustomerLocations({
      userType: userType,
      alldata: true,
      companyId: companyId,
    });
    setCustomerLocationId(data?.map((item) => item?.id)?.join());
  };
  // if assigned location to supervisor then use supervisor location else use all customer locations
  useEffect(() => {
    if (supervisorData) {
      const id: Array<any> = supervisorData?.customer_location_ids?.map(
        (item) => item?._id,
      );
      if (id?.length > 0) {
        setCustomerLocationId(id?.join());
      } else {
        fetchAllLocation(supervisorData?.company_id?._id);
      }
    }
  }, [supervisorData]);
  const loadWorkOrder = async () => {
    await fetchWorkOrder(
      userType,
      userId,
      page,
      limit,
      startDate,
      endDate,
      status,
      location,
      customerLocationId,
      customer,
      setLoader,
      setData,
      settotalPage,
      setStatusCount,
    );
  };
  const loadWorkOrderModel = async () => {
    await fetchWorkOrderModel({
      userType: userType,
      userId: userId,
      setLoader: setLoader,
      setData: setData,
      customerLocationId: customerLocationId,
    });
  };

  const loadCustomerData = async () => {
    await fetchCustomerData({
      userId: userId,
      userType: userType,
      allData: true,
      customerLocationId: customerLocationId,
      setData: setCustomers,
    });
  };

  useEffect(() => {
    if (userId && userType) {
      if (userType === "supervisor") {
        if (customerLocationId) {
          if (type === "one time") {
            loadWorkOrder();
          }
          if (type === "recurring") {
            loadWorkOrderModel();
          }
        } else {
          setLoader(false);
        }
      } else {
        if (type === "one time") {
          loadWorkOrder();
        }
        if (type === "recurring") {
          loadWorkOrderModel();
        }
      }
    }
  }, [
    userId,
    status,
    customerLocationId,
    customer,
    location,
    limit,
    page,
    type,
    startDate && endDate,
  ]);
  useEffect(() => {
    if (userId && userType) {
      if (userType === "supervisor") {
        if (customerLocationId) {
          loadCustomerData();
        }
      } else {
        loadCustomerData();
      }
    }
  }, [userId, customerLocationId]);
  const processedData =
    typeof customers === "object" && !Array.isArray(customers)
      ? [customers]
      : customers;
  const loadCustomerLocation = async () => {
    await fetchCustomerLocations(
      userType === "supervisor"
        ? {
            customerLocationId: customerLocationId,
            alldata: true,
            setCustomerLocations: setCustomerLocations,
          }
        : {
            customerLocationId: customerLocationId,
            alldata: true,
            setCustomerLocations: setCustomerLocations,
            companyId: userId,
          },
    );
  };
  useEffect(() => {
    if (userId && userType) {
      if (userType === "supervisor") {
        if (customerLocationId) {
          loadCustomerLocation();
        }
      } else {
        loadCustomerLocation();
      }
    }
  }, [userId, userType, customerLocationId]);
  useEffect(() => {
    if (customer) {
      loadCustomerLocation();
    }
  }, [customer]);
  const intl = useIntl();
  const HandleModelByProps = (data) => {
    if (data === false) {
      setEditId("");
    }
    if (data === true) {
      setEditId("");
      loadWorkOrder();
    }
    setShowDelete(false);
    setDeleteId("");
  };
  const HandleDelete = async (id) => {
    const formData = {
      id: id,
      status: "deleted",
    };
    let res;
    if (type === "one time") {
      res = await updateWorkorder(formData);
    } else {
      res = await deleteRecWorkOrder(id);
    }
    if (res?.success === true) {
      SuccessMessage("API.SUCCESS.WORKORDER.DELETE");
      setDeleteId("");
      setShowDelete(false);
      loadWorkOrder();
    }
  };
  useEffect(() => {
    if (Filterdata) {
      setIsCompletionDate(Filterdata?.some((item) => item?.completion_date));
    }
  }, [Filterdata]);

  useEffect(() => {
    if (type === "recurring") {
      setFilterdata(data);
    }
  }, [data]);
  useEffect(() => {
    if (startDate) {
      setCustomDateFilterError({
        end: "INPUT.VALIDATION.WORKORDER.FILTER.ERROR",
      });
    }
  }, [startDate]);
  useEffect(() => {
    if (endDate && startDate) {
      setCustomDateFilterError(null);
      if (!startDate) {
        setCustomDateFilterError({
          start: "INPUT.VALIDATION.WORKORDER.START.FILTER.ERROR",
        });
      }
    }
  }, [endDate, startDate]);

  const hasActiveContractors = async () => {
    if (!userId) {
      return true;
    }

    const params = new URLSearchParams();
    params.append("status", "active");
    params.append("limit", "1");
    params.append("page", "1");

    if (userType === "company") {
      params.append("company_id", userId);
    }

    if (userType === "supervisor") {
      const filter = [];
      filter.push({ supervisor_id: userId });
      if (customerLocationId) {
        filter.push({
          customer_location_ids: { $in: customerLocationId?.split(",") },
        });
      }
      params.append("filter", JSON.stringify({ $or: filter }));
    }

    const res = await getContractor(params);
    return res?.success !== true || res?.data?.length > 0;
  };

  const handleAddWorkOrder = async () => {
    if (
      userType !== "supervisor" &&
      appSettingsData &&
      appSettingsData?.isPlatformPaymentActive != undefined &&
      appSettingsData?.isPlatformPaymentActive === true
    ) {
      if (
        !userFullProfile?.id ||
        !userFullProfile?.stripe_customer_detail ||
        !userFullProfile?.stripe_customer_detail?.id ||
        !userFullProfile?.stripe_customer_payment_methods ||
        userFullProfile?.stripe_customer_payment_methods?.length == 0
      ) {
        toast.error(
          intl.formatMessage({
            id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND2",
            defaultMessage: "Please set up your payment method first",
          }),
        );
        return;
      }
      if (
        !userFullProfile?.stripe_customer_detail ||
        !userFullProfile?.stripe_customer_detail?.default_payment_method ||
        userFullProfile?.stripe_customer_detail?.default_payment_method ==
          null ||
        userFullProfile?.stripe_customer_detail?.default_payment_method ==
          "null" ||
        userFullProfile?.stripe_customer_detail?.default_payment_method == ""
      ) {
        toast.error(
          intl.formatMessage({
            id: "API.ERROR.PAYMENTMETHOD.DEFAULT.NOT.FOUND",
            defaultMessage: "Please set a default payment method first",
          }),
        );
        return;
      }
    }

    setCheckingContractors(true);
    try {
      const hasContractors = await hasActiveContractors();
      if (!hasContractors) {
        setShowNoContractorAlert(true);
        return;
      }
      window.location.href = "/schedule-work-order";
    } finally {
      setCheckingContractors(false);
    }
  };

  return (
    <MainWrapper>
      <ContentWithSpinner loader={loader} height="h-screen">
        <div className="py-3">
          <div className="mb-2">
            <h1 className="text-2xl  border-r border-neutral-200 pr-4">
              <FormattedMessage
                id="RECRUITER.WORKORDER.TITLE"
                defaultMessage="Work Order Management"
              />
            </h1>
          </div>
          <div className="flex justify-between w-full">
            <div className="flex flex-1 space-x-2 items-center">
              <Filter
                name={
                  status?.includes("publish") && status?.includes("draft") ? (
                    "All"
                  ) : status?.includes("publish") ? (
                    <FormattedMessage id="RECRUITER.WORKORDER.FILTER.TYPE.PUBLISH"></FormattedMessage>
                  ) : status?.includes("draft") ? (
                    <FormattedMessage id="RECRUITER.WORKORDER.FILTER.TYPE.ASSIGNED.DRAFT"></FormattedMessage>
                  ) : (
                    "Select"
                  )
                }
                label={
                  <FormattedMessage
                    id="MYJOB.FILTER.DROPDOWN.STATUS"
                    defaultMessage="Status"
                  />
                }
              >
                <Checkbox
                  id="publish"
                  name="publish"
                  onChange={(e) => CheckBoxHandle(e, status, setStatus)}
                  checked={status?.includes("publish")}
                  value="publish"
                  label={
                    <FormattedMessage id="RECRUITER.WORKORDER.FILTER.TYPE.PUBLISH"></FormattedMessage>
                  }
                ></Checkbox>
                <Checkbox
                  id="draft"
                  name="draft"
                  onChange={(e) => CheckBoxHandle(e, status, setStatus)}
                  checked={status?.includes("draft")}
                  value="draft"
                  label={
                    <FormattedMessage id="RECRUITER.WORKORDER.FILTER.TYPE.ASSIGNED.DRAFT"></FormattedMessage>
                  }
                ></Checkbox>
              </Filter>
              <DropDown
                labelClass="xl:text-base lg:text-sm"
                value={customer}
                label={intl.formatMessage({
                  id: "RECRUITER.WORKORDER.FILTER.CUSTOMER.TITLE",
                  defaultMessage: "Customer",
                })}
                dropdowndiv="mt-0 "
                onChange={(e) => SetCustomer(e.target.value)}
                className="rounded-lg"
              >
                <option value="">
                  <FormattedMessage
                    id="RECRUITER.WORKORDER.FILTER.SELECTCUSTOMER"
                    defaultMessage="Select Customer"
                  />
                </option>
                {processedData?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
              </DropDown>
              <DropDown
                labelClass="xl:text-base lg:text-sm"
                value={location}
                label={intl.formatMessage({
                  id: "RECRUITER.WORKORDER.FILTER.LOCATION",
                  defaultMessage: "Location",
                })}
                dropdowndiv="mt-0 w-40 relative group"
                onChange={(e) => setLocation(e.target.value)}
                className="rounded-lg"
              >
                <option value="">
                  <FormattedMessage
                    id="RECRUITER.WORKORDER.FILTER.SELECT.LOCATION"
                    defaultMessage="Select Location"
                  />
                </option>
                {(Array.isArray(customerLocations)
                  ? customerLocations
                  : [customerLocations]
                )?.map((item, index) => (
                  <option key={index} value={item?.id}>
                    {AddressDisplay(item?.address)}
                  </option>
                ))}
              </DropDown>
              <ReactDatePicker
                label={
                  <FormattedMessage
                    id="RECRUITER.WORKORDER.FILTER.SCHEDULED.START.DATE"
                    defaultMessage="Scheduled Start date"
                  />
                }
                inputClass="rounded-lg"
                labelClass="mt-0 text-black text-center xl:text-base lg:text-sm"
                InputDivClass={` ${
                  customDateFilterError?.start ? "mt-10" : "mt-0"
                } w-40`}
                placeholder="Enter company joining date"
                isDefaultSelected={false}
                onChange={(date) => setStartDate(date)}
                selected={startDate}
                error={customDateFilterError?.start}
              ></ReactDatePicker>
              <ReactDatePicker
                label={
                  <FormattedMessage
                    id="RECRUITER.WORKORDER.FILTER.SCHEDULED.END.DATE"
                    defaultMessage="Scheduled End date"
                  />
                }
                inputClass="rounded-lg"
                labelClass="mt-0 text-black text-center xl:text-base lg:text-sm"
                InputDivClass={` ${
                  customDateFilterError?.end ? "mt-10" : "mt-0"
                } w-40`}
                placeholder="Enter company joining date"
                isDefaultSelected={false}
                onChange={(date) => setEndDate(date)}
                selected={endDate}
                error={customDateFilterError?.end}
              ></ReactDatePicker>
              {/* <DropDown className='rounded-lg' labelClass='xl:text-base lg:text-sm' dropdowndiv='mt-0' label={<FormattedMessage id='MYJOB.FILTER.DROPDOWN.TYPE.TITLE' defaultMessage='Work Order Type' />}  value={type} onChange={(e)=> setType(e.target.value)}>
  <option value={'one time'}>One Time</option>
  <option value={'recurring'}>Recurring</option>
   </DropDown> */}
            </div>
            {(userType === "company" ||
              (userType === "supervisor" &&
                supervisorData?.access?.work_order_management
                  ?.add_work_order)) && (
              <div className="xl:max-w-[20%] lg:max-w-[25%]">
                <Button
                  text={
                    <FormattedMessage
                      id="RECRUITER.WORKORDER.ADD.WORK.ORDER"
                      defaultMessage="Add Work Order"
                    />
                  }
                  disabled={
                    checkingContractors ||
                    (appSettingsData &&
                      appSettingsData?.isPlatformPaymentActive != undefined &&
                      appSettingsData?.isPlatformPaymentActive === true &&
                      !userFullProfile?.id)
                  }
                  onClick={handleAddWorkOrder}
                ></Button>
                {/* <Link to="/schedule-work-order">
                  <WhiteBtn
                    title={
                      <FormattedMessage
                        id="RECRUITER.WORKORDER.ADD.WORK.ORDER"
                        defaultMessage="Add Work Order"
                      />
                    }
                  />
                </Link> */}
                <div className="flex justify-center">
                  <Link to={`/schedule-work-order/${instruction}`}>
                    {" "}
                    <p className="xl:text-base font-medium underline cursor-pointer">
                      Instructions
                    </p>
                  </Link>
                </div>
              </div>
            )}
          </div>
          <div
            className={`flex items-center w-full max-w-full ${
              type === "recurring" ? "justify-end" : "justify-between"
            } mt-8 space-x-4`}
          >
            {type === "one time" && (
              <StatusTab
                className="xl:w-full lg:w-full md:w-full"
                data={data}
                setFilterdata={setFilterdata}
                statusCount={statusCount}
                setActive={setActive}
                onActiveType={setActiveType}
              />
            )}
          </div>

          <div className="overflow-x-auto mt-4 rounded-[20px]">
            <table className="w-full text-left condidate-table">
              <thead className="bg-[#FAF9F8] border-collapse border-b border-neutral-200 capitalize">
                <tr>
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="WORKORDER.TABLE.COL.WORKORDER.TITLE"
                      defaultMessage="Title"
                    />
                  </th>
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="WORKORDER.TABLE.COL.CUSTOMER.NAME.TITLE"
                      defaultMessage="Customer Name"
                    />
                  </th>
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="WORKORDER.TABLE.COL.NAME.LOCATION"
                      defaultMessage="Location"
                    />
                  </th>
                  {type === "one time" && (
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="WORKORDER.TABLE.COL.NAME.SCHEDULE.DATE"
                        defaultMessage="Schedule Date"
                      />
                    </th>
                  )}
                  {isCompletionDate && (
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="WORKORDER.TABLE.COL.NAME.COMPLETION.DATE"
                        defaultMessage="Completion Date"
                      />
                    </th>
                  )}

                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="WORKORDER.TABLE.COL.NAME.RATE.DATE"
                      defaultMessage="Amount"
                    />
                  </th>
                  <th scope="col" className="px-6 py-4 text-base ">
                    <FormattedMessage
                      id="WORKORDER.TABLE.COL.NAME.STATUS"
                      defaultMessage="Status"
                    />
                  </th>
                  {(type === "recurring" ||
                    (type === "one time" &&
                      (active === "scheduled" ||
                        active === "in progress" ||
                        (active === "rejected" &&
                          activeType === "contract")))) && (
                    <th scope="col" className="px-6 py-4 text-base ">
                      <FormattedMessage
                        id="WORKORDER.TABLE.COL.NAME"
                        defaultMessage="Action"
                      />
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {Filterdata?.length > 0 ? (
                  Filterdata?.map((item, index) => (
                    <TableRow
                      active={active}
                      activeType={activeType}
                      key={index}
                      type={type}
                      item={item}
                      setEditId={setEditId}
                      setShowDelete={setShowDelete}
                      setDeleteId={setDeleteId}
                      isCompletionDate={isCompletionDate}
                      editPermission={
                        supervisorData?.access?.work_order_management
                          ?.update_work_order
                      }
                      deletePermission={
                        supervisorData?.access?.work_order_management
                          ?.delete_work_order
                      }
                      rejectPermission={
                        supervisorData?.access?.work_order_management
                          ?.delete_work_order
                      }
                    />
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      <Empty text="No records to display" className="py-14" />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {Filterdata?.length > 0 && (
              <div className="flex justify-center">
                <p className=" mt-3">
                  {/* Workorders:{data?.length} of {limit}  */}
                  Page:{page} of {totalPage}
                </p>
              </div>
            )}
            {totalPage > 1 && (
              <Pagination page={page} totalPage={totalPage} setPage={setPage} />
            )}
          </div>
        </div>
      </ContentWithSpinner>
      {userType === "supervisor" && <TermsAgreePopup></TermsAgreePopup>}
      {editId ? (
        <WorkOrderPopup
          page={type === "one time" ? "workorder" : "Workordermodel"}
          editId={editId}
          HandleModelByProps={HandleModelByProps}
        />
      ) : null}
      {showDelete && (
        <ModelWrapper
          rounded="rounded-[10px]"
          background="bg-[#00000099]"
          position="fixed"
          opacity="opacity-100"
          topPosition="top-[10%]"
          rightPosition="inset-0"
          width="w-[50%] mx-auto"
          showModal={showDelete}
          HandleModelByProps={HandleModelByProps}
        >
          <DeleteConfirmation
            onCancel={() => HandleModelByProps(false)}
            onDelete={() => HandleDelete(deleteId)}
          />
        </ModelWrapper>
      )}
      {showNoContractorAlert && (
        <ModelWrapper
          noCancel={true}
          HandleModelByProps={() => setShowNoContractorAlert(false)}
          rounded="rounded-[10px]"
          background="bg-[#00000099]"
          position="fixed"
          opacity="opacity-100"
          topPosition="top-[20%]"
          rightPosition="inset-0"
          width="w-[40%] mx-auto"
          showModal={showNoContractorAlert}
        >
          <div className="flex items-center justify-between rounded-t">
            <button className="p-1 ml-auto bg-transparent border-0 text-black opacity-1 float-right text-3xl leading-none font-semibold outline-none focus:outline-none">
              <span
                onClick={() => setShowNoContractorAlert(false)}
                className="bg-transparent text-black opacity-1 h-6 w-6 text-2xl block outline-none focus:outline-none"
              ></span>
            </button>
          </div>
          <p className="text-lg mx-6 mb-6 text-center">
            You must have contractors added before you can schedule work orders.
            Create a job post to hire a contractor or invite an existing
            contractor in the contractor menu.
          </p>
          <div className="flex justify-center pb-6">
            <WhiteBtn
              onClick={() => setShowNoContractorAlert(false)}
              mainClass="w-40 flex justify-center"
              title="OK"
            ></WhiteBtn>
          </div>
        </ModelWrapper>
      )}
    </MainWrapper>
  );
};
